/** 慢页面追踪 */
import './index.scss'
import React from 'react'
import { message,Input,Button } from "antd";
import api from "../../lib/api";
import IconFont from '../../components/IconFont/index';
import DateTimePicker from "../../components/DateTimePicker";
import ComTable from "./components/ComTable";

class slowPage extends React.Component {
  isPageSizeChange = false;
  state = {
    dateTimeVal: '24小时',
    startTime: '',
    endTime: '',
    page: 1,
    size: 30,
    tbData: [],
    loading: false,
    showFilterPopup: false,
    filterData: {
      url: '',
      minLoadTime: null,
      maxLoadTime: null,
      browserVersion:'',
      systemType:''
    },
    filterDataClone: {},
    pagination: {
      current: 1,
      pageSize: 30,
      defaultPageSize: 30,
      pageSizeOptions: [30, 50, 100],
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      onShowSizeChange: (current, size) => this.pageSizeChange(current, size),
      showTotal: total => `共 ${total} 条数据`,
    }
  };
  // 表格数据
  slowPageData() {
    this.setState({ loading: true });
    const { startTime, endTime, page, size,filterData } = this.state;
    const params = {
      startTime,
      endTime,
      page,
      size,
      ...filterData
    };
    api.slowPageData(params).then(res => {
      this.setState({ loading: false });
      if (res.success && res.status === 200) {
        this.setState({
          tbData: res.data || [],
          pagination: Object.assign(this.state.pagination, {
            pageSize: res.size,
            current: res.page,
            total: res.total
          })
        })
      } else {
        message.error(res.message);
      }
    })
  };
  pageSizeChange = (current, size) => {
    this.isPageSizeChange = true;
    this.setState({
      page: 1,
      size
    }, () => {
      this.slowPageData();
    });
  };
  pageChange = (pagination, filters, sorter, extra) => {
    if (this.isPageSizeChange) {
      this.isPageSizeChange = false;
      return
    }
    this.setState({
      page: pagination.current,
      size: pagination.pageSize
    }, () => {
      this.slowPageData();
    });
  };
  handleDateTimePicker = (dateTimeVal, startTime, endTime) => {
    this.setState({
      dateTimeVal,
      startTime,
      endTime,
      page: 1,
      pagination: Object.assign(this.state.pagination, { current: 1 })
    }, () => {
      this.slowPageData();
    });
  };
  /** 显示/隐藏筛选弹窗 */
  handleShowFilter(bol) {
    bol ? this.setState({
      filterDataClone: JSON.parse(JSON.stringify(this.state.filterData))
    }) : this.setState({
      filterData: JSON.parse(JSON.stringify(this.state.filterDataClone))
    })
    this.setState({
      showFilterPopup: bol
    })
  };
  /** 更改筛选数据 */
  handleFilterChange(key, val) {
    let obj = this.state.filterData;
    obj[key] = val.target.value;
    this.setState({filterData:obj});
  };
  /** 确定筛选 */
  handleConfirmFilter(){
    this.slowPageData();
    this.setState({
      showFilterPopup: false
    })
  };
  render() {
    const { history } = this.props;
    const { dateTimeVal, loading, tbData, pagination,showFilterPopup,filterData } = this.state;
    return (
      <div className='card'>
        <div className='clear mBtm15 filter-row'>
          <IconFont type="icon-shaixuantiaojian" style={{ fontSize: 26 }} className="filter-icon" onClick={() => this.handleShowFilter(true)} />
          <DateTimePicker comClassName='float-r' value={dateTimeVal} handleDateTimePicker={this.handleDateTimePicker} />
        </div>
        <ComTable dateTimeVal={dateTimeVal} history={history} loading={loading} tbData={tbData} pagination={pagination} pageChange={this.pageChange} />
        {/** 筛选弹窗 */}
        {showFilterPopup ? <div className="filter-popup">
          <div className="popup-shadow"></div>
          <div className="filter-module">
            <div className="filter-input">
              <div>
                <p>URL</p>
                <Input allowClear={true} value={filterData.url} onChange={val => this.handleFilterChange('url', val)} />
              </div>
              <div className="double-input">
                <p>页面加载时间</p>
                <Input value={filterData.minLoadTime} onChange={val => this.handleFilterChange('minLoadTime', val)} />
                <span>-</span>
                <Input value={filterData.maxLoadTime} onChange={val => this.handleFilterChange('maxLoadTime', val)} />
              </div>
              <div>
                <p>浏览器版本</p>
                <Input allowClear={true} value={filterData.browserVersion} onChange={val => this.handleFilterChange('browserVersion', val)} />
              </div>
              <div>
                <p>系统</p>
                <Input allowClear={true} value={filterData.systemType} onChange={val => this.handleFilterChange('systemType', val)} />
              </div>
            </div>
            <p>
              <Button type="primary" onClick={() => this.handleConfirmFilter()} >确定</Button>
              <Button onClick={() => this.handleShowFilter(false)} >取消</Button>
            </p>
          </div>
        </div> : ''}
      </div>
    );
  }
}

export default slowPage;
